export default __webpack_public_path__ + "static/media/2.44c1d8b6.png";